import { previewPriorAuthForRxDraft } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  PreviewPriorAuthRequestT,
  PreviewPriorAuthResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPreviewPriorAuth(
  userId: string,
  request: PreviewPriorAuthRequestT,
  signal?: AbortSignal
): Promise<PreviewPriorAuthResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await previewPriorAuthForRxDraft(userId, request, config);
  return lotusHealthZod.previewPriorAuthForRxDraftResponse.parse(
    response.data
  ) as PreviewPriorAuthResponseT;
}
